<div class="mc-spring-board">
  <div class="mc-spring-board-form-body">
    <mc-review-file-user-list [licenseId]="reviewFile?.LicenseId" listClass="mc-list-no-outer-spacing" [reviewFileId]="reviewFile?.Id"></mc-review-file-user-list>
  </div>
</div>